import React from "react";
import { useState, useEffect } from 'react';
import { Field } from "../types/types";


type Props = {
    item: Field;
    sort: any;
};


const FieldListItem = ({item, sort}: Props) => {
    const [field, setField] = useState(item);
    const [showActions, setShowActions] = useState(false);

    useEffect(() => {
        setField(item);
    }, [item]);

    const getSortValue = () => {
        if(sort) {
            const {property} = sort;
            //console.log("C112923 field", field);
            if(field.stats.hasOwnProperty(property)) {
                return field.stats[property].values[field.stats[property].values.length - 1].toFixed(1);
            }
        }
    }

    return (
        <div key={field.id} id={`field_${field.id}`} className="align-items-center d-flex text-dark">
            <div className="d-flex flex-column w-100">
                <div className="d-flex justify-content-between">
                    <div className="text-xs text-muted" style={{fontSize:'0.65rem', lineHeight:'0.75rem'}}>{field.farm? field.farm.name : ""}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <h5 className="font-weight-bold text-base text-truncate mb-0">{field.name}</h5>
                    <div className="text-base-lg" title={sort ? sort.title : ""}>{getSortValue()}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="text-sm text-muted">
                        <span className="text-capitalize">{field.crop ? field.crop.name : 'na - a'}</span> <span className="mx-1">&bull;</span>{field.area.toFixed(0)} ac
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FieldListItem;
